export class WorkingDetail{
    public empCd: string
    public workingYm :string
    public workingDate: string
    public monthlyStatus: string    //�Ζ��e�[�u������
    public dailyStatus: string
    public holidayKbn: string
    public workingKbn: string
    public vacationKbn: string
    public teleworkKbn: string
    public tardyFlg: boolean
    public leavingEarlyFlg: boolean
    public trainDelayFlg: boolean
    public offDutyDate: string
    public exchangeDateBase: string
    public exchangeDateFrom: string
    public exchangeDateTo: string
    public shiftTimeStart: string
    public shiftTimeEnd: string
    public wkTimeStart: string
    public wkTimeEnd: string
    public teleworkStart1: string
    public teleworkEnd1: string
    public teleworkStart2: string
    public teleworkEnd2: string
    public restTimeChangeFlg: boolean
    public restTimeStart1: string
    public restTimeEnd1: string
    public restTimeStart2: string
    public restTimeEnd2: string
    public restTimeStart3: string
    public restTimeEnd3: string
    public restTimeStart4: string
    public restTimeEnd4: string
    public restTimeStart5: string
    public restTimeEnd5: string
    public restTimeStart6: string
    public restTimeEnd6: string
    public restTimeStart7: string
    public restTimeEnd7: string
    public restTimeStart8: string
    public restTimeEnd8: string
    public restTimeStart9: string
    public restTimeEnd9: string
    public restTimeStart10: string
    public restTimeEnd10: string
    public restTimeTotal: string
    public wktimeActual: string
    public wktimeOvertime: string
    public wktimeMidnight: string
    public wktimeLegalHoliday: string
    public workingRemarks: string
    public dateBaseTime: string
    public renewDate :Date
    public lastRegistrationDate: Date
    public lastRegistrationEmpNm: string
    public decisionRemarks: string
    public decisionDate: string
    public decisionEmpCd: string
    public decisionEmpNm: string
    public approvalDate1st: Date
    public approvalEmpCd1st: string
    public approvalEmpNm1st: string
    public approvalDate2nd: Date
    public approvalEmpCd2nd: string
    public approvalEmpNm2nd: string
    public approvalDate3rd: Date
    public approvalEmpCd3rd: string
    public approvalEmpNm3rd: string
    public confirmDate1st: Date
    public confirmEmpCd1st: string
    public confirmEmpNm1st: string
    public confirmDate2nd: Date
    public confirmEmpCd2nd: string
    public confirmEmpNm2nd: string
    public confirmDate3rd: Date
    public confirmEmpCd3rd: string
    public confirmEmpNm3rd: string

}
